/**
 * Copia texto para a área de transferência. A API moderna exige página segura e permissão, e há
 * navegador embutido (ou política da empresa) que a recusa; o plano B é o comando antigo de copiar
 * uma seleção, que funciona nos navegadores comuns. Resolve `false` quando nenhum dos dois deu —
 * a tela então pede para a pessoa copiar à mão.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return copyWithSelection(text);
  }
}

function copyWithSelection(text: string): boolean {
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  try {
    // Obsoleto, mas é o único caminho quando a API nova é negada; sem ele, o botão só falharia.
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    area.remove();
  }
}
